import { sortAlphabetical } from "@biblioteksentralen/utils";
import { FrontendLocale } from "@libry-content/localization";
import { LCWork, toCordataLanguageCode } from "@libry-content/integrations";
import { sift } from "radash";

/**
 * Note that this function extracts a different representative manifestation for each associated work; we can't use
 * the representative manifestation for the work (containing the aggregate manifestation) of the current view.
 */
export const getWorksSortedOnRepresentativeManifestationTitle = (
  associatedWorks: LCWork[],
  lang: FrontendLocale,
  representativeLanguages?: string
): LCWork[] => {
  return sortAlphabetical(
    sift(
      associatedWorks.map((associatedWork) => {
        const sortedTriple = associatedWork.getSortedWorkTriple({
          representativeLanguages: representativeLanguages ?? toCordataLanguageCode(lang),
        });
        return associatedWork.withRepresentativeManifestationId(sortedTriple?.manifestationId);
      })
    ),
    ({ representativeWorkTriple }) => representativeWorkTriple?.getFormattedManifestationTitle() ?? ""
  );
};
